import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        component: () =>
            import('../views/PageTypes/Login.vue')
    },
    {
        path: '/login',
        component: () =>
            import('../views/PageTypes/Login.vue')
    },
    {
        path: '/sso-callback',
        component: () =>
            import('../views/PageTypes/SsoCallback.vue')
    },
    {
        path: '/kalender',
        component: () =>
            import('../views/PageTypes/Calendar.vue')
    },
    {
        path: '/admin',
        component: () =>
            import('../views/PageTypes/Admin.vue')
    },
    {
        path: '/medlemmer',
        component: () =>
            import('../views/PageTypes/Medlemmer.vue')
    },
    {
        path: '/mine-bookinger',
        component: () =>
            import('../views/PageTypes/MyBookings.vue')
    },
    {
        path: '/forbrug',
        component: () =>
            import('../views/PageTypes/Forbrug.vue')
    },
    {
        path: '/booking/opret',
        component: () =>
            import('../views/PageTypes/BookingCreate.vue')
    },
    {
        path: '/booking/:id/ret',
        component: () =>
            import('../views/PageTypes/BookingEdit.vue')
    },
    {
        path: '/booking/:id',
        component: () =>
            import('../views/PageTypes/Booking.vue')
    },
    {
        path: '/:url',
        beforeEnter(to, from, next) {
            // PHP pages (e.g. forbrug.php) must not be handled by the SPA catch-all
            if (/\.php(\/|$)/i.test(to.path)) {
                window.location.replace(to.fullPath)
                return
            }
            next()
        },
        component: () =>
            import('../views/PageTypes/Page.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router